import { memo, useMemo } from 'react';

import { ListPagination } from '../../../shared/uiComponents/Table/pagination';
import { AuthorizationCardAdmin, AuthorizationCardBcba, TemporaryAuthorizationCard } from './authorizationCard';
import { MobileViewProps } from '../types';

export const MobileViewAdmin = memo(({ data }: MobileViewProps) => {
	const cards = useMemo(
		() =>
			data.query?.map((x, index) => (
				<AuthorizationCardAdmin key={`mob-row-${x.client.id || index}-${index}`} item={x} />
			)),
		[data.query],
	);

	return (
		<>
			{cards}
			<ListPagination type="auth" {...data} />
		</>
	);
});
MobileViewAdmin.displayName = 'MobileViewAdmin';

export const MobileViewBCBA = memo(({ data }: MobileViewProps) => {
	const cards = useMemo(
		() =>
			data.query?.map((x, index) => (
				<AuthorizationCardBcba key={`mob-row-${x.client.id || index}-${index}`} item={x} />
			)),
		[data.query],
	);

	return <>{cards}</>;
});
MobileViewBCBA.displayName = 'MobileViewBCBA';

export const MobileViewTemporaryAuthorizations = memo(({ data }: MobileViewProps) => {
	const cards = useMemo(
		() =>
			data.query?.map((x, index) => (
				<TemporaryAuthorizationCard key={`mob-row-${x.client.id || index}-${index}`} item={x} />
			)),
		[data.query],
	);

	return (
		<>
			{cards}
			<ListPagination type="tempAuth" {...data} />
		</>
	);
});
MobileViewTemporaryAuthorizations.displayName = 'MobileViewTemporaryAuthorizations';
